import { UomCategoryDetailPage } from '@/features/uom-category/pages/UomCategoryDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/uom-category/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["uom_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: UomCategoryDetailPage,
})
